import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { IS_LOAD, IS_SEARCH } from 'src/app/shared/models/load.models';
import { QcResponse } from 'src/app/shared/models/qcResponse.model';
import { EnvironmentFacadeService } from 'src/app/shared/services/environment.facade.service';
import { PaginatorFacadeService } from 'src/app/shared/services/paginator.facade.service';
import { IMSearchFacadeService } from './integration-management-search.facade.service';
@Injectable({ providedIn: 'root' })
export class IntegrationManagementService {
  constructor(
    private http: HttpClient,
    private environmentFacade: EnvironmentFacadeService,
    private facade: IMSearchFacadeService,
    private paginatorFacadeService: PaginatorFacadeService,
  ) {}

  getTypes(): Observable<QcResponse> {
    const url = `${this.environmentFacade.getEnvironment()}/rest/v1/integration/types`;
    return this.http.get<QcResponse>(url, {
      withCredentials: true,
      context: new HttpContext().set(IS_LOAD, true),
    });
  }

  getIntegrationTypes(): Observable<any> {
    const selectedOrder =
      this.paginatorFacadeService.selectedOrder === 'Ascending' ? 'ASC' : 'DESC';

    const selectedSortField =
      this.paginatorFacadeService.selectedSortField === 'Integration system'
        ? 'INTEGRATIONTYPE'
        : 'INTEGRATIONNAME';

    const start = this.paginatorFacadeService.itemsNumber * this.paginatorFacadeService.pageIndex;

    const url = `${this.environmentFacade.getEnvironment()}/rest/v1/integration/findByFilter?start=${start}&pageSize=${
      this.paginatorFacadeService.itemsNumber
    }&sortField=${selectedSortField}&sortOrder=${selectedOrder}`;

    const body = {
      integrationType: this.facade.selectedSystem,
      integrationName: this.facade.selectedName,
      active: this.facade.activeStatus,
      inactive: this.facade.inActiveStatus,
    };
    return this.http.post<QcResponse>(url, body, {
      withCredentials: true,
      context: new HttpContext().set(IS_SEARCH, true),
    });
  }

  countByFilterIntegration(): Observable<QcResponse> {
    const url = `${this.environmentFacade.getEnvironment()}/rest/v1/integration/countByFilter`;
    const body = {
      integrationName: this.facade.selectedName,
      integrationType: this.facade.selectedSystem,
      active: this.facade.activeStatus,
      inactive: this.facade.inActiveStatus,
    };

    return this.http.post<QcResponse>(url, body, {
      withCredentials: true,
      context: new HttpContext().set(IS_SEARCH, true),
    });
  }
}
